import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "store/actions";
import profileApi from "api/profile";
import useNotify from "hooks/useNotify";
import { scrollIntoView } from "utils/helper";
import { vatCertificationType } from "utils/constantValues";

export default function UseVatInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditVat = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        vat: !values?.isVatExempt
          ? {
              isVatExempt: values?.isVatExempt || false,
              vatCountryId: values?.vatCountryId || "",
              vatRegistrationNumber: values?.vatRegistrationNumber || "",
              vatCertificationId:
                values?.vatCertification ||
                userDetails.userFiles.find(
                  (file) => file.type === vatCertificationType
                )?.id,
            }
          : { isVatExempt: values?.isVatExempt },
      };

      dispatch(
        actions.updateVat(payload, async (isSuccess, err) => {
          setIsLoading(false);
          if (isSuccess) {
            const userData = await profileApi.getUserProfileByIdApi(
              userDetails?.id
            );
            dispatch(actions.setUserDetails(userData));
            notifySuccess("Has been updated successfully");
            scrollIntoView("vatSection");
          } else {
            notifyError(
              err?.data?.error ?? err?.message ?? "Something went wrong!"
            );
          }
        })
      );
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return { onEditVat, isVatLoading: isLoading };
}
